import { TypographyPropsVariantOverrides } from "@mui/material";
import { Variant } from "@mui/material/styles/createTypography";
import { OverridableStringUnion } from "@mui/types";
import { forwardRef } from "react";

import MDBox from "@/components/atoms/MDBox";
import MDTypography from "@/components/atoms/MDTypography";

type MDBadgeDotProps = React.ComponentPropsWithoutRef<typeof MDBox> & {
  variant?: "contained" | "gradient";
  color: "primary" | "secondary" | "info" | "success" | "warning" | "error" | "light" | "dark";
  size: "xs" | "sm" | "md" | "lg";
  badgeContent: string;
  font?: {
    color?:
      | "inherit"
      | "primary"
      | "secondary"
      | "info"
      | "success"
      | "warning"
      | "error"
      | "light"
      | "dark"
      | "text"
      | "white";
    weight?: "light" | "regular" | "medium" | "bold";
  };
};

const MDBadgeDot = forwardRef<HTMLDivElement, MDBadgeDotProps>(
  ({ variant = "contained", color = "dark", size = "xs", badgeContent, font, ...rest }, ref) => {
    let finalSize = "0.375rem";
    let fontSize: OverridableStringUnion<Variant | "inherit", TypographyPropsVariantOverrides> =
      "caption";
    let padding = "0.45em 0.775em";

    if (size === "sm") {
      finalSize = "0.5rem";
      fontSize = "caption";
      padding = "0.45em 0.775em";
    } else if (size === "lg") {
      finalSize = "0.625rem";
      fontSize = "body2";
      padding = "0.85em 1.375em";
    } else if (size === "md") {
      finalSize = "0.5rem";
      fontSize = "button";
      padding = "0.65em 1em";
    }

    return (
      <MDBox ref={ref} display="flex" alignItems="center" p={padding} {...rest}>
        <MDBox
          component="i"
          display="inline-block"
          width={finalSize}
          height={finalSize}
          // borderRadius="50%"
          bgColor={color}
          variant={variant}
          mr={1}
        />
        <MDTypography
          variant={fontSize}
          fontWeight={font?.weight ? font.weight : "regular"}
          color={font?.color ? font.color : "dark"}
          sx={{ lineHeight: 0 }}
        >
          {badgeContent}
        </MDTypography>
      </MDBox>
    );
  }
);

MDBadgeDot.displayName = "MDBadgeDot";
export default MDBadgeDot;
